/// <reference path="../../typings/browser.d.ts" />


namespace Application.Models {
    'use strict';

    export interface IStreamPipe {
        active: boolean;
        sourceInputLevels: String[];
        sinkOutputLevels: String[];
        firstConnection: () => IStreamPipeBlockConnection;
        lastConnection: () => IStreamPipeBlockConnection;
        href: string;
        sourceNodeHref: string;
        sinkNodeHref: string;
        sourceBlockId: number;
        sinkBlockId: number;

    }
    
    interface IEmbedded {
        streamPipeBlockConnections: IStreamPipeBlockConnection[];
    }


    export interface IBlockConnection {
        name: string;
        connectionsAvailable: number;
        blockName: string;
        availableConnections: boolean;
        direction: string;
        connectionTypeName: string;
        id?: number;
        connected?: boolean;
        parameters?: IBlockConnectionParameters;
        targetPorts?: string;
    }

    export interface IBlockConnectionParameters {
        passphrase: string;
        needReTake?: boolean;
    }

    export interface IStreamPipeBlockConnection {
        origBlockConnection: IBlockConnection;
        destBlockConnection: IBlockConnection;
    }

    export interface IStreamPipeBlockConnectionInfo {
        destBlock?: Models.IBlock;
        destBlockConnection: IBlockConnection;
        destBlockId: number;
        href: string;
        origBlock?: Models.IBlock;
        origBlockConnection: IBlockConnection;
        origBlockId: number;
        pipeStreamId: number;
        position: number;
        streamPipeBlockConnections: Object;
    }

    export interface IStreamPipeElement {
        blockI: Models.IBlock;
        incomingConnection: Models.IStreamPipeBlockConnectionInfo;
        outgoingConnection: Models.IStreamPipeBlockConnectionInfo;
        networkNodeI: Models.NetworkNode;
        blockId: number;
        encoder: boolean;
        decoder: boolean;
        outgoingDigestedConnectionInfo?: {
            type: 'internet' | 'cable';
            name: string;
        };
        hasHistorical?: boolean;
        presetPath: string[];
        srtflexUrl: string;
    }

    export class StreamPipeBlockConnectionInfo implements IStreamPipeBlockConnectionInfo {
        public destBlockConnection: IBlockConnection;
        public destBlockId: number;
        public href: string;
        public origBlockConnection: IBlockConnection;
        public origBlockId: number;
        public pipeStreamId: number;
        public position: number;
        public streamPipeBlockConnections: Object;

        public static Empty(): StreamPipeBlockConnectionInfo {
            return new StreamPipeBlockConnectionInfo();
        }

        constructor() {
            this.destBlockConnection = undefined;
            this.destBlockId = undefined;
            this.href = '';
            this.origBlockConnection = undefined;
            this.origBlockId = undefined;
            this.pipeStreamId = undefined;
            this.position = undefined;
            this.streamPipeBlockConnections = undefined;
        }
    }

    export class StreamPipe implements IStreamPipe {
        public active: boolean;
        public sourceInputLevels: String[];
        public sinkOutputLevels: String[];
        public href: string;
        public sourceNodeHref: string;
        public sinkNodeHref: string;
        public sourceBlockId: number;
        public sinkBlockId: number;
        private _embedded: IEmbedded;

        public static Empty(): StreamPipe {
            return new StreamPipe();
        }

        constructor() {
            // empty constructor
            this.active = false;
            this.sourceInputLevels = [];
            this.sinkOutputLevels = [];
            this.href = '';
            this.sourceNodeHref = undefined;
            this.sinkNodeHref = undefined;
            this._embedded = {streamPipeBlockConnections: []};
        }

        public firstConnection(): IStreamPipeBlockConnection {
            if (this._embedded.streamPipeBlockConnections.length > 0) {
                return this._embedded.streamPipeBlockConnections[0];
            } else {
                return undefined;
            }
        }

        public lastConnection(): IStreamPipeBlockConnection {
            let length: number = this._embedded.streamPipeBlockConnections.length;
            if (length > 0) {
                return this._embedded.streamPipeBlockConnections[length - 1];
            } else
                return undefined;
        }
    }

    export interface IStreamPipeNodes {
        sourceHref: string;
        sinkHref: string;
    }
}
